import { Injectable } from '@angular/core';
import { MatSidenav } from '@angular/material';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SidenavService {
  private sidenav: MatSidenav;
  isSidenavOpened$ = new BehaviorSubject<boolean>(true);

  public setSidenav(sidenav: MatSidenav) {
    this.sidenav = sidenav;
  }

  public getSidenav() {
    return this.sidenav;
  }

  public updateSidenavStatus() {
    this.isSidenavOpened$.next(this.sidenav.opened);
  }

  public closeSideNavIfSmallWidthAsync(sidenav: MatSidenav, threshold = 730) {
    if (Object.is(sidenav, this.sidenav)) {
      this.closeSideNavIfSmallWidth(threshold);
    }
  }

  public closeSideNavIfSmallWidth(threshold = 730) {
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width <= threshold) {
      this.sidenav.close();
      this.updateSidenavStatus();
    }
  }

  public openSideNavIfSmallWidth(threshold = 730) {
    const width = window.innerWidth > 0 ? window.innerWidth : screen.width;
    if (width <= threshold) {
      this.sidenav.open();
      this.updateSidenavStatus();
    }
  }

  public openSidenav() {
    this.sidenav.open();
    this.updateSidenavStatus();
  }
}
